import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { service } from '@ember/service';
import { waitFor } from '@ember/test-waiters';

import { adapterAction } from '@mainmatter/ember-api-actions';

import { apiBaseURL, paymentLinkNamespace } from 'receivable-invoices-js/constants/hosts';

export default class PaymentLinkAdapter extends JSONAPIAdapter {
  host = apiBaseURL;
  namespace = paymentLinkNamespace;
  useFetch = true;

  @service localeManager;

  pathForType() {
    return 'payment_links/checkout';
  }

  @waitFor
  async createPayment({ resourceId, paymentMethod, creditCardToken, userEmail }) {
    let locale = this.localeManager.locale;

    let data = {
      type: 'payment_link_checkouts',
      attributes: {
        payment_method: paymentMethod,
        credit_card_token: creditCardToken,
        locale,
        user_email: userEmail,
      },
    };

    let { data: dataResponse } = await adapterAction(this, 'payment-link', {
      method: 'POST',
      path: `?resource_id=${resourceId}`,
      data: {
        data,
      },
    });

    return dataResponse?.attributes.payment_link;
  }
}
